import { END_SESSION } from '../actions/authActions';
import { SET_CAMPAIGNS } from '../actions/campaignActions';

const DEFAULT_STATE = [];

export default function campaignsReducer(state = DEFAULT_STATE, { type, payload = [] }) {
  switch (type) {
    case END_SESSION:
      return DEFAULT_STATE;
    case SET_CAMPAIGNS:
      return payload;
    default:
      return state;
  }
}

export const getCampaigns = (state) => {
  return state;
};
